import type { IWorkflowDefinition, WorkflowEntityType } from '@pulse/shared';

import { apiFetch } from '../../../lib/api-client';
import { extractErrorMessage } from '../../../lib/api-error.util';

export async function fetchWorkflowDefinition(entityType: WorkflowEntityType): Promise<IWorkflowDefinition | null> {
  const res = await apiFetch(`/api/v1/workflow-definitions?entityType=${entityType}`);
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to fetch workflow steps'));
  const definitions = (await res.json()) as IWorkflowDefinition[];
  return definitions[0] ?? null;
}
